/* == Free gift note to cart note 2025-05-21 B == */
document.addEventListener('DOMContentLoaded', function() {
  const freeGiftNote = document.getElementById('freeGiftnote');
  const freeGiftCheckbox = document.getElementById('freeGiftcheckbox');
  
  if (!freeGiftNote || !freeGiftCheckbox) return;
  
  if (freeGiftNote.value.trim()) {
    freeGiftCheckbox.checked = true;
  }
  
  freeGiftNote.addEventListener('input', function() {
    freeGiftCheckbox.checked = Boolean(freeGiftNote.value.trim());
  });

  freeGiftNote.addEventListener('change', function() {
    if (freeGiftNote.getAttribute('name') !== 'free_gift_note') {
      return;
    }
    
    fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: freeGiftNote.value }),
      keepalive: true
    }).then((response) => {
      if (!response.ok) throw new Error(`cart/update.js failed: ${response.status}`);
    }).catch((error) => {
      console.error('Failed to update cart note', error);
    });

  });
});

/* == Free gift note to cart note 2025-05-21 E == */